<template>
  <b-card-body no-body>
    <b-form-row @keyup.enter="buscarConfiguracao" class="pt-3">
      <b-col cols="12">
        <b-row>
          <b-col cols="8" class="d-flex justify-content-center align-items-center">
            <lg-form-input v-model="nome" label="Nome:"  />
          </b-col>

          <b-col cols="4" class="d-flex justify-content-center align-items-center">
            <b-button id="btnBuscarA" class="mr-2 my-2" size="sm" pill variant="primary" @click="buscarConfiguracao">
              <div class="btn-size-alinhamento">

                <b-icon icon="search" />
                <b-tooltip target="btnBuscarA" title="Buscar"></b-tooltip>
              </div>
            </b-button>

            <b-button id="btnLimparAl" class="mr-2 my-2" size="sm" pill variant="primary" @click="limparFiltro">
              <div class="btn-size-alinhamento">

                <b-icon icon="eraser" />
                <b-tooltip target="btnLimparAl" title="Limpar"></b-tooltip>
              </div>
            </b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-form-row>

    <b-table responsive :busy="busy" small class="mt-2" :hover="true" show-empty :items="configuracoes"
      :fields="camposTabela">
      <template #empty>
        <p>Nenhum registro encontrado</p>
      </template>
      <template #table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong> Carregando...</strong>
        </div>
      </template>

      <template #cell(acoes)="row">
        <b-button id="btnEditar" size="sm" variant="primary" @click="editar(row.item)">
          <b-icon icon="pencil-square" />
          <b-tooltip target="btnEditar" title="Editar..."></b-tooltip>
        </b-button>
      </template>
      <template #cell(valorPropriedadeLabel)="row">
        {{ row.item.valorPropriedadeLabel == null ? "Não se aplica" : row.item.valorPropriedadeLabel }}
      </template>
    </b-table>
    <AlmoxarifadoCentralModal v-if="showAlmoxarifadoCentralModal" :configuracao="configuracaoEdit"
      @salvo="onConfiguracaoSalva" @close="onModalClose" />
    <EmailConfigModal v-if="showEmailConfigModal" :configuracao="configuracaoEdit" @salvo="onConfiguracaoSalva"
      @close="onModalClose" />
    <ConfiguracaoSimplesModal v-if="showConfiguracaoSimplesModal" :configuracao="configuracaoEdit"
      @salvo="onConfiguracaoSalva" @close="onModalClose" />
    <DepartamentoResponsavelModal v-if="showDepartamentoResponsavelModal" :configuracao="configuracaoEdit"
      @salvo="onConfiguracaoSalva" @close="onModalClose" />
  </b-card-body>
</template>

<script>
import ConfiguracaoSistemaService from "@/core/api/ConfiguracaoSistemaService";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import { ListResourceMixin } from "@/core/mixins/resource";
import ConfirmMixin from "@/core/mixins/confirm";
import AlmoxarifadoCentralModal
  from "@/modules/administrador/painel-de-configuracao/components/modal/AlmoxarifadoCentralModal.vue";
import Swal from "sweetalert2";
import EmailConfigModal from "@/modules/administrador/painel-de-configuracao/components/modal/EmailConfigModal.vue";
import ConfiguracaoSimplesModal
  from "@/modules/administrador/painel-de-configuracao/components/modal/ConfiguracaoSimplesModal.vue";
import DepartamentoResponsavelModal
  from "@/modules/administrador/painel-de-configuracao/components/modal/DepartamentoResponsavelModal.vue";

export default {
  components: {
    DepartamentoResponsavelModal,
    ConfiguracaoSimplesModal,
    EmailConfigModal,
    AlmoxarifadoCentralModal,
    LgFormInput,
  },
  data() {
    return {
      busy: false,
      nome: "",
      configuracoes: [],
      configuracaoEdit: {
        id: null,
        ano: null,
        dataInicio: null,
        dataFim: null,
        departamentoId: null,
        departamentoNome: "",
      },
      showAlmoxarifadoCentralModal: false,
      showEmailConfigModal: false,
      showConfiguracaoSimplesModal: false,
      showDepartamentoResponsavelModal: false,
      camposTabela: [
        { key: "tituloPropriedade", label: "Nome" },
        { label: "Valor", key: "valorPropriedadeLabel" },
        { key: "acoes", label: "", tdClass: "text-center", thClass: "text-center" },
      ],
    };
  },
  methods: {
    async buscarConfiguracao() {
      this.busy = true;
      const response = await ConfiguracaoSistemaService.buscarPorTipo(3, this.nome);
      this.configuracoes = response.data;
      this.busy = false;
    },
    async limparFiltro() {
      this.nome = "";
      this.configuracoes = [];
      this.buscarConfiguracao();

    },
    editar(item) {
      this.configuracaoEdit = { ...item };
      switch (item.grupoConfiguracaoSistemaId) {
        case 1:
          this.showConfiguracaoSimplesModal = true;
          break;
        case 6:
          this.showEmailConfigModal = true;
          break;
        case 7:
          this.showDepartamentoResponsavelModal = true;
          break;
        case 26:
          this.showAlmoxarifadoCentralModal = true;
          break;
        case 3:
          Swal.fire({
            title: "Atenção",
            text: "Este parâmetro não poderá ser modificado, pois o mesmo influenciará no cálculo do preço médio",
            icon: "warning",
            confirmButtonText: "OK",
          });
          break;
        default:
          break;
      }
    },
    onConfiguracaoSalva() {
      this.buscarConfiguracao();
      this.showAlmoxarifadoCentralModal = false;
      this.showEmailConfigModal = false;
      this.showConfiguracaoSimplesModal = false;
      this.showDepartamentoResponsavelModal = false;
    },
    onModalClose() {
      this.showAlmoxarifadoCentralModal = false;
      this.showEmailConfigModal = false;
      this.showConfiguracaoSimplesModal = false;
      this.showDepartamentoResponsavelModal = false;
    },
  },
  mixins: [ListResourceMixin, ConfirmMixin],
  async mounted() {
    await this.buscarConfiguracao();
  },
};
</script>
